



















































import { defineComponent, PropType, computed } from '@vue/composition-api';
import NavigationItem from '@/components/NavigationItem.vue';
import UiChannelTree from '@/data/UiChannelTree';
import SharedState from '@/data/SharedState';

// @ts-ignore
export default defineComponent({
  components: {
    NavigationItem
  },
  props: {
    uiChannelTree: {
      type: Object as PropType<UiChannelTree>,
      required: true
    },
    isRoot: {
      type: Boolean,
      required: true
    },
    longestParentWord: {
      type: String,
      required: true
    },
    isSmallLayout: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    'nav-click': (/*id: number*/) => true,
    'select-click': (/*id: number*/) => true
  },
  setup(props, context) {

    const hasParent = computed(() => props.uiChannelTree.hasParent());
    const hasChildren = computed(() => props.uiChannelTree.hasChildren());

    const longestParentWordC = computed((): string => {
      return props.longestParentWord;
    });

    return {
      hasChildren,
      hasParent,
      longestParentWordC
    }
  }

});


